module.exports = __webpack_public_path__ + "Roboto-Thin.44b78f142603eb69f593.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Thin.woff
// module id = 613
// module chunks = 2